export default __webpack_public_path__ + "static/media/field.716935aa.jpg";